const getItemsPerSlide = (isMobile: boolean, betweenMobileAndDesktop: boolean): number => {
	if (isMobile) return 2;
	if (betweenMobileAndDesktop) return 3;
	return 4;
};

export {getItemsPerSlide};
